<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Voluntários" pageTitle="Voluntários" />
            <VolunteersContent />
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader';
import PageTitle from '../Common/PageTitle';
import VolunteersContent from '../Volunteers/VolunteersContent';
import FooterArea from '../Layouts/FooterArea';

export default {
    name: 'VolunteersPage',
    components: { MainHeader, PageTitle, VolunteersContent, FooterArea },
    mounted() { 
        document.body.classList.add('body-bg-f8faff'); 
    },
};
</script>
